"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertTextInputResponsesWithDataSources = void 0;
function assertTextInputResponsesWithDataSources(handleSubmissionMock, responses) {
    expect(handleSubmissionMock.mock.calls.length).toBe(1);
    expect(responses.length).toBe(2);
    var textInputResponse = responses.find(function (r) { return r.questionId === 1196601; });
    expect(textInputResponse.answer).toBe("blue-green");
    expect(textInputResponse.associatedId).toBe(1089102);
    expect(textInputResponse.questionId).toBe(1196601);
    expect(textInputResponse.questionRootId).toBe(1196602);
    var textAreaResponse = responses.find(function (r) { return r.questionId === 1196801; });
    expect(textAreaResponse.answer).toBe("some text");
    expect(textAreaResponse.associatedId).toBeUndefined();
    expect(textAreaResponse.questionId).toBe(1196801);
    expect(textAreaResponse.questionRootId).toBe(1196801);
}
exports.assertTextInputResponsesWithDataSources = assertTextInputResponsesWithDataSources;
//# sourceMappingURL=textInputResponses.js.map